import { render, staticRenderFns } from "./PageLoader.vue?vue&type=template&id=5a48a900&"
import script from "./PageLoader.vue?vue&type=script&lang=ts&"
export * from "./PageLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports